import { Project } from '../project';
import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project.service';

@Component({
  selector: 'app-user-start-project',
  templateUrl: './user-start-project.component.html',
  styleUrls: ['./user-start-project.component.sass']
})
export class UserStartProjectComponent implements OnInit {
  title: string = "Wybierz dom z bazy gotowych projektów lub wgraj zdjęcie swojego domu";
  next: string = "/palettes-info/0";
  prev: string = "/start-project";
  project: Project
  constructor(private projectService: ProjectService) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
  }
}
